export enum FilterOperation {
	Greater = '>',
	Equals = 'eq',
	NotEquals = 'neq',
	Lower = '<',
	Contains = 'contains',
	NotContains = 'notContains',
}

export enum FilterAssociation {
	And = 'AND',
	Or = 'OR',
}

export enum FilterType {
	Equals = 'equals',
	StringContains = 'string-contains',
	NumberCompare = 'number-compare',
	Empty = 'empty',
}
